import ForecastReportService from 'app/services/forecastReport/forecastReport.service';
import DateUtilsService from 'external-services/date-utils-service';
import AdminService from 'external-services/diary-admin-service/admin.service';

const NS = 'ForecastReportCtrl';

export default function ForecastReportCtrl(
  $log, $scope, $localStorage, $timeout, unregister
) {
  "ngInject";

  var vm = this;
  //-- define public properties
  vm.currency = AdminService.getVenue()?.currency;
  vm.todayDate = new Date();
  vm.forecastDate = new Date();
  vm.compareFrom = new Date();
  vm.compareFrom.setDate(vm.compareFrom.getDate() - 8);
  vm.compareTo = new Date();
  vm.compareTo.setDate(vm.compareTo.getDate() - 1);
  vm.hideDays = true;
  vm.loading = false;
  vm.loadError = false;
  vm.printing = false;
  vm.includeEvents = false;
  vm.datePeriodInvalid = false;
  //-- define public methods
  vm.lastWeek = lastWeek;
  vm.lastFortnight = lastFortnight;
  vm.lastMonth = lastMonth;
  vm.sameWeekLastYear = sameWeekLastYear;
  vm.getServices = getServices;
  vm.getReport = getReport;
  vm.clearReport = clearReport;
  vm.retry = retry;
  vm.printReport = printReport;

  var listeners = [];
  listeners.push($scope.$watch('vm.forecastDate', clear));
  listeners.push($scope.$watch('vm.compareFrom', datesChanged));
  listeners.push($scope.$watch('vm.compareTo', datesChanged));
  listeners.push($scope.$watch('vm.includeEvents', clearReport));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  function datesChanged() {
    clear();
    vm.datePeriodInvalid = false;
    if (!vm.compareFrom || !vm.compareTo) {
      return;
    }
    var daysDiff = DateUtilsService.daysBetweenDates(vm.compareFrom, vm.compareTo);
    if (daysDiff > 90) {
      vm.datePeriodInvalid = true;
    }
  }

  function clear() {
    vm.services = null;
    vm.reportDays = null;
  }

  function clearReport() {
    vm.reportDays = null;
  }

  function lastWeek() {
    vm.compareFrom = new Date();
    vm.compareFrom.setDate(vm.compareFrom.getDate() - 8);
    vm.compareTo = new Date();
    vm.compareTo.setDate(vm.compareTo.getDate() - 1);
  }

  function lastFortnight() {
    vm.compareFrom = new Date();
    vm.compareFrom.setDate(vm.compareFrom.getDate() - 15);
    vm.compareTo = new Date();
    vm.compareTo.setDate(vm.compareTo.getDate() - 1);
  }

  function lastMonth() {
    vm.compareFrom = new Date();
    vm.compareFrom.setDate(vm.compareFrom.getDate() - 31);
    vm.compareTo = new Date();
    vm.compareTo.setDate(vm.compareTo.getDate() - 1);
  }

  function sameWeekLastYear() {
    vm.compareFrom = new Date(vm.forecastDate.getTime());
    vm.compareFrom.setFullYear(vm.compareTo.getFullYear() - 1);
    vm.compareTo = new Date(vm.forecastDate.getTime());
    vm.compareTo.setDate(vm.compareTo.getDate() + 7);
    vm.compareTo.setFullYear(vm.compareTo.getFullYear() - 1);
  }

  function getServices() {
    vm.loading = true;
    ForecastReportService.getServices(vm.forecastDate).then(function (response) {
      vm.loading = false;
      vm.services = response.data.map(function (name) {
        return {
          name: name
        };
      });
      for (var i = 0; i < vm.services.length; i++) {
        var service = vm.services[i];
        service.price = ($localStorage[service.name]) ? Number($localStorage[service.name]) : 0;
      }
      vm.services.push({
        name: 'Events',
        price: ($localStorage['Events']) ? Number($localStorage['Events']) : 0 // jshint ignore:line
      });
    }).catch(function () {
      vm.loading = false;
      vm.loadError = true;
    });
  }

  function saveServicePrices() {
    for (var i = 0; i < vm.services.length; i++) {
      var service = vm.services[i];
      $localStorage[service.name] = service.price;
    }
  }

  function getReport() {
    vm.loading = true;
    saveServicePrices();
    ForecastReportService.getReport(vm.forecastDate, vm.compareFrom, vm.compareTo, vm.services).then(function (response) {
      vm.loading = false;
      vm.reportDays = response.data;
      parseReport();
    }).catch(function (err) {
      console.log(err);
      vm.loading = false;
      vm.loadError = true;
    });
  }

  function parseReport() {
    for (var i = 0; i < vm.reportDays.length; i++) {
      var day = vm.reportDays[i];
      var eventsTotals = {
        present: {
          bookings: 0,
          bookingCovers: 0,
          walkIns: 0,
          walkInCovers: 0,
          totalRevenue: 0
        },
        historic: {
          bookings: 0,
          bookingCovers: 0,
          walkIns: 0,
          walkInCovers: 0,
          totalRevenue: 0
        },
        future: {
          bookings: 0,
          bookingCovers: 0,
          walkIns: 0,
          walkInCovers: 0,
          totalRevenue: 0
        }
      };

      for (var s = 0; s < day.forecastData.length; s++) {
        var service = day.forecastData[s];

        service.present.totalCovers = Math.round(service.present.bookingCovers + service.present.walkInCovers);
        service.historic.totalCovers = Math.round(service.historic.bookingCovers + service.historic.walkInCovers);
        service.future.totalCovers = Math.round(service.future.bookingCovers + service.future.walkInCovers);


        service.present.bookingsStatus = getStatus(service.present.bookings, service.historic.bookings);
        service.present.bookingCoversStatus = getStatus(service.present.bookingCovers, service.historic.bookingCovers);
        service.present.walkInsStatus = getStatus(service.present.walkIns, service.historic.walkIns);
        service.present.walkInCoversStatus = getStatus(service.present.walkInCovers, service.historic.walkInCovers);
        service.present.totalCoversStatus = getStatus(service.present.totalCovers, service.historic.totalCovers);
        service.present.totalRevenueStatus = getStatus(service.present.totalRevenue, service.historic.totalRevenue);

        service.future.bookingsStatus = getStatus(service.future.bookings, service.historic.bookings);
        service.future.bookingCoversStatus = getStatus(service.future.bookingCovers, service.historic.bookingCovers);
        service.future.walkInsStatus = getStatus(service.future.walkIns, service.historic.walkIns);
        service.future.walkInCoversStatus = getStatus(service.future.walkInCovers, service.historic.walkInCovers);
        service.future.totalCoversStatus = getStatus(service.future.totalCovers, service.historic.totalCovers);
        service.future.totalRevenueStatus = getStatus(service.future.totalRevenue, service.historic.totalRevenue);

        if (!vm.includeEvents && service.serviceName === 'Events') {
          eventsTotals.present.bookings += service.present.bookings;
          eventsTotals.present.bookingCovers += service.present.bookingCovers;
          eventsTotals.present.walkIns += service.present.walkIns;
          eventsTotals.present.walkInCovers += service.present.walkInCovers;
          eventsTotals.present.totalRevenue += service.present.totalRevenue;

          eventsTotals.historic.bookings += service.historic.bookings;
          eventsTotals.historic.bookingCovers += service.historic.bookingCovers;
          eventsTotals.historic.walkIns += service.historic.walkIns;
          eventsTotals.historic.walkInCovers += service.historic.walkInCovers;
          eventsTotals.historic.totalRevenue += service.historic.totalRevenue;

          eventsTotals.future.bookings += service.future.bookings;
          eventsTotals.future.bookingCovers += service.future.bookingCovers;
          eventsTotals.future.walkIns += service.future.walkIns;
          eventsTotals.future.walkInCovers += service.future.walkInCovers;
          eventsTotals.future.totalRevenue += service.future.totalRevenue;
        }
      }

      if (!vm.includeEvents) {
        day.presentTotal.bookings -= eventsTotals.present.bookings;
        day.presentTotal.bookingCovers -= eventsTotals.present.bookingCovers;
        day.presentTotal.walkIns -= eventsTotals.present.walkIns;
        day.presentTotal.walkInCovers -= eventsTotals.present.walkInCovers;
        day.presentTotal.totalRevenue -= eventsTotals.present.totalRevenue;

        day.historicTotal.bookings -= eventsTotals.historic.bookings;
        day.historicTotal.bookingCovers -= eventsTotals.historic.bookingCovers;
        day.historicTotal.walkIns -= eventsTotals.historic.walkIns;
        day.historicTotal.walkInCovers -= eventsTotals.historic.walkInCovers;
        day.historicTotal.totalRevenue -= eventsTotals.historic.totalRevenue;

        day.futureTotal.bookings -= eventsTotals.future.bookings;
        day.futureTotal.bookingCovers -= eventsTotals.future.bookingCovers;
        day.futureTotal.walkIns -= eventsTotals.future.walkIns;
        day.futureTotal.walkInCovers -= eventsTotals.future.walkInCovers;
        day.futureTotal.totalRevenue -= eventsTotals.future.totalRevenue;
      }

      day.historicTotal.totalCovers = Math.round(day.historicTotal.bookingCovers + day.historicTotal.walkInCovers);
      day.presentTotal.totalCovers = Math.round(day.presentTotal.bookingCovers + day.presentTotal.walkInCovers);
      day.futureTotal.totalCovers = Math.round(day.futureTotal.bookingCovers + day.futureTotal.walkInCovers);

      day.presentTotal.bookingsStatus = getStatus(day.presentTotal.bookings, day.historicTotal.bookings);
      day.presentTotal.bookingCoversStatus = getStatus(day.presentTotal.bookingCovers, day.historicTotal.bookingCovers);
      day.presentTotal.walkInsStatus = getStatus(day.presentTotal.walkIns, day.historicTotal.walkIns);
      day.presentTotal.walkInCoversStatus = getStatus(day.presentTotal.walkInCovers, day.historicTotal.walkInCovers);
      day.presentTotal.totalCoversStatus = getStatus(day.presentTotal.totalCovers, day.historicTotal.totalCovers);
      day.presentTotal.totalRevenueStatus = getStatus(day.presentTotal.totalRevenue, day.historicTotal.totalRevenue);

      day.futureTotal.bookingsStatus = getStatus(day.futureTotal.bookings, day.historicTotal.bookings);
      day.futureTotal.bookingCoversStatus = getStatus(day.futureTotal.bookingCovers, day.historicTotal.bookingCovers);
      day.futureTotal.walkInsStatus = getStatus(day.futureTotal.walkIns, day.historicTotal.walkIns);
      day.futureTotal.walkInCoversStatus = getStatus(day.futureTotal.walkInCovers, day.historicTotal.walkInCovers);
      day.futureTotal.totalCoversStatus = getStatus(day.futureTotal.totalCovers, day.historicTotal.totalCovers);
      day.futureTotal.totalRevenueStatus = getStatus(day.futureTotal.totalRevenue, day.historicTotal.totalRevenue);
    }
  }

  function getStatus(current, previous) {
    if (previous === current) {
      return 'equal';
    }
    if (previous < current) {
      return 'greater';
    }
    if (previous > current) {
      return 'lower';
    }
  }

  function retry() {
    vm.loading = false;
    vm.loadError = false;
  }

  function printReport() {
    vm.printing = true;
    $timeout(function () {
      setTimeout(function () {
        window.print();
        printDone();
      }, 200);
    }, 100);
  }

  function printDone() {
    vm.printing = false;
    setTimeout(function () {
      vm.printing = false;
    }, 200);
  }
}
